module.exports = __webpack_public_path__ + "static/derave-91a886e447b7578e778c7de7344caa32.jpg";